export const UPDATE_CHEM_PROD_TITLE = 'UPDATE_CHEM_PROD_TITLE';

export default {
  UPDATE_CHEM_PROD_TITLE
};
